/* Header vehicle-sync — externalized + deferred 2026-08-19 (was 13KB inline in header.liquid). The one
   Liquid value (garage empty-label) is passed via the #cpg-vehsync-config JSON block; the code is now
   Liquid-free + cacheable. Deferred: runs after parse (and after cpg-ymm-widget defines CPGFitment). */
(function () {
  var CPG_VEHSYNC_EMPTY_LABEL = (function(){ try { return JSON.parse((document.getElementById('cpg-vehsync-config')||{}).textContent || '"Add Vehicle"'); } catch(e){ return 'Add Vehicle'; } })();

    var syncInterval = null;
    var lastStableActiveVehicle = null;
    var lastStableVehicleCount = 0;

    function ready(callback) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback);
      } else {
        callback();
      }
    }

    function safeParse(value) {
      if (!value || typeof value !== 'string') return null;
      try { return JSON.parse(value); } catch (error) { return null; }
    }

    function firstValue(object, keys) {
      if (!object || typeof object !== 'object') return '';
      for (var i = 0; i < keys.length; i += 1) {
        var value = object[keys[i]];
        if (value !== undefined && value !== null && String(value).trim() !== '') {
          return String(value).trim();
        }
      }
      return '';
    }

    function normalizeVehicle(vehicle) {
      if (!vehicle) return null;
      if (typeof vehicle === 'string') {
        var parsed = safeParse(vehicle);
        if (parsed) return normalizeVehicle(parsed);
        return { label: vehicle.trim() };
      }

      if (vehicle.vehicle && typeof vehicle.vehicle === 'object') vehicle = vehicle.vehicle;
      if (vehicle.activeVehicle && typeof vehicle.activeVehicle === 'object') vehicle = vehicle.activeVehicle;
      if (vehicle.selectedVehicle && typeof vehicle.selectedVehicle === 'object') vehicle = vehicle.selectedVehicle;

      var year = firstValue(vehicle, ['year', 'Year', 'vehicleYear']);
      var make = firstValue(vehicle, ['make', 'Make', 'vehicleMake']);
      var model = firstValue(vehicle, ['model', 'Model', 'vehicleModel']);
      var submodel = firstValue(vehicle, ['submodel', 'subModel', 'Submodel', 'trim']);
      var label = firstValue(vehicle, ['label', 'title', 'name', 'vehicleName', 'description']);

      if (!label) label = [year, make, model, submodel].filter(Boolean).join(' ');
      if (!label) return null;

      return {
        year: year,
        make: make,
        model: model,
        submodel: submodel,
        label: label.replace(/\s+/g, ' ').trim(),
        raw: vehicle
      };
    }

    function normalizeVehicleList(value) {
      if (!value) return [];
      if (typeof value === 'string') value = safeParse(value);
      if (!value) return [];

      if (Array.isArray(value)) return value.map(normalizeVehicle).filter(Boolean);

      if (value.vehicles && Array.isArray(value.vehicles)) {
        return value.vehicles.map(normalizeVehicle).filter(Boolean);
      }
      if (value.vehicleList && Array.isArray(value.vehicleList)) {
        return value.vehicleList.map(normalizeVehicle).filter(Boolean);
      }
      if (value.garage && Array.isArray(value.garage)) {
        return value.garage.map(normalizeVehicle).filter(Boolean);
      }

      if (typeof value === 'object') {
        var single = normalizeVehicle(value);
        if (single) return [single];
        return Object.keys(value).map(function (key) { return normalizeVehicle(value[key]); }).filter(Boolean);
      }

      return [];
    }

    function getApiVehicleState() {
      var active = null;
      var list = [];

      try {
        if (window.CPGFitment) {
          var activeMethods = ['getActiveVehicle', 'getSelectedVehicle', 'getVehicle'];
          for (var i = 0; i < activeMethods.length && !active; i += 1) {
            if (typeof window.CPGFitment[activeMethods[i]] === 'function') {
              active = normalizeVehicle(window.CPGFitment[activeMethods[i]]());
            }
          }

          var listMethods = ['getVehicleList', 'getVehicles', 'getGarage'];
          for (var j = 0; j < listMethods.length && !list.length; j += 1) {
            if (typeof window.CPGFitment[listMethods[j]] === 'function') {
              list = normalizeVehicleList(window.CPGFitment[listMethods[j]]());
            }
          }

          if (!active) active = normalizeVehicle(window.CPGFitment.activeVehicle || window.CPGFitment.selectedVehicle || window.CPGFitment.vehicle);
          if (!list.length) list = normalizeVehicleList(window.CPGFitment.vehicles || window.CPGFitment.vehicleList || window.CPGFitment.garage);
        }
      } catch (error) {}

      try {
        if (window.Convermax) {
          if (!list.length && typeof window.Convermax.getVehicleList === 'function') {
            list = normalizeVehicleList(window.Convermax.getVehicleList());
          }
          if (!active && typeof window.Convermax.getCurrentVehicle === 'function') {
            active = normalizeVehicle(window.Convermax.getCurrentVehicle());
          }
        }
      } catch (error) {}

      return { active: active, list: list };
    }

    function getStoredVehicleState() {
      var active = null;
      var list = [];
      var activeKeys = [
        'cpg_active_vehicle', 'cpgActiveVehicle', 'cpg_selected_vehicle', 'cpgSelectedVehicle',
        'selectedVehicle', 'activeVehicle', 'cm_current_vehicle', 'cmCurrentVehicle'
      ];
      var listKeys = [
        'cpg_vehicle_list', 'cpgVehicleList', 'cpg_garage', 'cpgGarage',
        'cm_vehicle_list', 'cmVehicleList', 'Convermax_vehicle_list', 'garage'
      ];

      try {
        for (var i = 0; i < activeKeys.length && !active; i += 1) {
          active = normalizeVehicle(window.localStorage.getItem(activeKeys[i]));
        }
        for (var j = 0; j < listKeys.length && !list.length; j += 1) {
          list = normalizeVehicleList(window.localStorage.getItem(listKeys[j]));
        }
      } catch (error) {}

      return { active: active, list: list };
    }

    function getDomActiveVehicle() {
      var selectors = [
        '[data-cpg-active-vehicle-name]', '[data-cpg-vehicle-text]',
        '#cm-garage .current-vehicle', '#cm-garage [class*="current-vehicle"]',
        '#cm-garage .garage-vehicle.is-active', '#cm-garage [aria-current="true"]'
      ];

      for (var i = 0; i < selectors.length; i += 1) {
        var node = document.querySelector(selectors[i]);
        var text = node ? String(node.textContent || '').replace(/\s+/g, ' ').trim() : '';
        if (text && !/add vehicle|selected vehicle|my garage/i.test(text)) return normalizeVehicle(text);
      }
      return null;
    }

    function getGarageCountFromDom() {
      var node = document.querySelector('#cm-garage .garage-size, #cm-garage [class*="garage-size"], #cpGarageIconTrigger .garage-size, #cpGarageIconTriggerMobile .garage-size');
      if (!node) return 0;
      var count = parseInt(String(node.textContent || '').replace(/[^0-9]/g, ''), 10);
      return Number.isFinite(count) ? count : 0;
    }

    function ensureBadge(trigger) {
      var badge = trigger.querySelector('.cp-ref-garage-count');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'cp-cart-count cp-ref-cart-badge cp-ref-garage-count';
        badge.setAttribute('aria-hidden', 'true');
        trigger.appendChild(badge);
      } else {
        badge.classList.add('cp-cart-count', 'cp-ref-cart-badge');
      }
      return badge;
    }

    function updateGarageHeader() {
      var trigger = document.getElementById('cpGarageTriggerDesktop');
      if (!trigger) return;

      var label = trigger.querySelector('[data-cp-active-vehicle]');
      var badge = ensureBadge(trigger);
      var apiState = getApiVehicleState();
      var storedState = getStoredVehicleState();
      var active = apiState.active || storedState.active || getDomActiveVehicle();
      var list = apiState.list.length ? apiState.list : storedState.list;
      var count = list.length || getGarageCountFromDom() || (active ? 1 : 0);

      // Owner 2026-07-24 (Option A): do NOT re-adopt a saved-list vehicle as
      // active — GARAGE_KEY is the single source of truth for the active car,
      // otherwise "reset vehicle" appears to not work (header resurrects it).

      /* Some fitment APIs briefly return an empty value while refreshing.
         Keep the last confirmed vehicle so the label does not alternate
         between "Add Vehicle" and the selected vehicle — EXCEPT when our own
         adapter explicitly reports no vehicle (Option A reset/remove,
         2026-07-24): that verdict is authoritative, so drop the caches
         instead of resurrecting the removed car. */
      var adapterSaysEmpty = false;
      try { adapterSaysEmpty = Boolean(window.CPGFitment) && !window.CPGFitment.hasVehicle(); } catch (error) {}
      if (active && active.label) {
        lastStableActiveVehicle = active;
      } else if (adapterSaysEmpty) {
        lastStableActiveVehicle = null;
        lastStableVehicleCount = 0;
        active = null;
      } else if (lastStableActiveVehicle) {
        active = lastStableActiveVehicle;
      }

      if (count > 0) {
        lastStableVehicleCount = count;
      } else if (active && lastStableVehicleCount > 0) {
        count = lastStableVehicleCount;
      } else if (active) {
        count = 1;
      }

      if (label) {
        var nextLabel = active && active.label
          ? active.label
          : CPG_VEHSYNC_EMPTY_LABEL;

        if (label.textContent !== nextLabel) {
          label.textContent = nextLabel;
        }
        label.title = active && active.label ? active.label : '';
      }

      if (badge.textContent !== String(count)) {
        badge.textContent = String(count);
      }
      trigger.classList.toggle('has-garage-count', count > 0);
      trigger.classList.toggle('has-active-vehicle', Boolean(active));
      trigger.setAttribute('data-garage-count', String(count));
      trigger.setAttribute('aria-label', active ? 'Shopping for ' + active.label + '. Open My Garage' : 'Add a vehicle');

      var mobileTrigger = document.getElementById('cpGarageTrigger');
      var mobileBadge = mobileTrigger ? mobileTrigger.querySelector('[data-cp-mobile-garage-count]') : null;

      if (mobileBadge) {
        mobileBadge.textContent = String(count);
        mobileBadge.hidden = count < 1;
        mobileBadge.setAttribute('aria-hidden', count > 0 ? 'false' : 'true');
      }

      if (mobileTrigger) {
        mobileTrigger.classList.toggle('has-garage-count', count > 0);
        mobileTrigger.setAttribute('data-garage-count', String(count));
        mobileTrigger.setAttribute('aria-label', active ? 'Shopping for ' + active.label + '. Open My Garage' : 'Add a vehicle');
        mobileTrigger.classList.toggle('has-active-vehicle', Boolean(active));

        var barVeh = mobileTrigger.querySelector('[data-cp-hv2-vehicle]');
        if (barVeh) {
          var barText = active && active.label ? active.label : 'Add your vehicle to see only parts that fit';
          if (barVeh.textContent !== barText) barVeh.textContent = barText;
        }
        var barPill = mobileTrigger.querySelector('[data-cp-hv2-pill]');
        if (barPill) barPill.hidden = !active;
        var barAdd = mobileTrigger.querySelector('[data-cp-hv2-add]');
        if (barAdd) barAdd.hidden = Boolean(active);
      }

      var hv2Dot = document.querySelector('[data-cp-hv2-gdot]');
      if (hv2Dot) hv2Dot.hidden = !active;
    }

    function scheduleUpdates() {
      [0, 150, 400, 900, 1600].forEach(function (delay) {
        window.setTimeout(updateGarageHeader, delay);
      });
    }

    function start() {
      scheduleUpdates();
      if (syncInterval) window.clearInterval(syncInterval);
      syncInterval = window.setInterval(updateGarageHeader, 2500);

      document.addEventListener('click', function (event) {
        if (event.target.closest('#cpGarageTriggerDesktop, #cpGarageTrigger, #cm-garage, .cm_garageDropdown, [data-cpg-garage-button]')) {
          scheduleUpdates();
        }
      }, true);

      ['cpg:vehicle-selected', 'cpg:vehicle-changed', 'cpg:garage-updated', 'fitment:vehicle-change', 'vehicle:change', 'garage:change'].forEach(function (eventName) {
        document.addEventListener(eventName, scheduleUpdates);
        window.addEventListener(eventName, scheduleUpdates);
      });

      window.addEventListener('storage', function (event) {
        if (/vehicle|garage|fitment/i.test(String(event.key || ''))) scheduleUpdates();
      });

      /* Do not observe the complete document here. Updating the counter itself
         creates DOM mutations and caused an endless observer/update loop. */
      if (window.MutationObserver) {
        var garageObserverTarget = document.querySelector(
          '#cm-garage, .cm_garageDropdown, [data-cpg-garage-root], [data-cpg-vehicle-picker]'
        );

        if (garageObserverTarget && garageObserverTarget.dataset.cpGarageHeaderObserved !== 'true') {
          garageObserverTarget.dataset.cpGarageHeaderObserved = 'true';

          var observerTimer = null;
          new MutationObserver(function () {
            window.clearTimeout(observerTimer);
            observerTimer = window.setTimeout(updateGarageHeader, 100);
          }).observe(garageObserverTarget, {
            childList: true,
            subtree: true,
            characterData: true,
            attributes: true
          });
        }
      }
    }

    ready(start);
    document.addEventListener('shopify:section:load', start);
  })();
